import { useEffect, useState } from 'react'
import es from '../i18n/es.json'
import en from '../i18n/en.json'

export type Locale = 'es' | 'en'
export const useLocale = () => {
  const [locale, setLocale] = useState<Locale>(() => (localStorage.getItem('talenxa-locale') as Locale) || 'es')
  useEffect(() => localStorage.setItem('talenxa-locale', locale), [locale])
  return { locale, setLocale, copy: locale === 'es' ? es : en }
}
